import {Box, Flex, P} from 'exsportia-components'
import {Formik} from 'formik'
import React, {FC, useMemo} from 'react'

import {Button} from '../../../ui/components/button/button'
import {TextArea} from '../../../ui/components/input/text-area'
import {useLocale} from '../../../utils/i18n'
import {getMembershipCancelReasonSchema, MEMBERSHIP_CANCEL_REASON_MAX_LENGTH} from './membership-cancel-reason'

type Props = {
  isSending: boolean
  onSubmit: (reason: string) => void
  onClose: () => void
}

type FormValues = {reason: string}

export const MembershipCancelRequestForm: FC<Props> = ({isSending, onSubmit, onClose}) => {
  const {l} = useLocale()
  const validationSchema = useMemo(() => getMembershipCancelReasonSchema(l), [l])

  return (
    <Formik<FormValues>
      initialValues={{reason: ''}}
      validationSchema={validationSchema}
      onSubmit={(values) => onSubmit(values.reason.trim())}
    >
      {({values, submitForm}) => {
        const length = values.reason.trim().length
        const handleSendClick = () => {
          submitForm().catch(() => undefined)
        }
        return (
          <Box data-testid='membership-cancel-form'>
            <P fontSize={'body'}>{l('membershipCancel_formIntro')}</P>
            <Box mt={'12px'}>
              <TextArea
                id='reason'
                label={l('membershipCancel_reasonLabel')}
                placeholder={l('membershipCancel_reasonPlaceholder')}
                required
              />
              <P
                fontSize={'body'}
                textAlign={'right'}
                data-testid='membership-cancel-counter'
                color={length > MEMBERSHIP_CANCEL_REASON_MAX_LENGTH ? 'error' : 'text-secondary'}
              >
                {l('membershipCancel_counter', {current: length, max: MEMBERSHIP_CANCEL_REASON_MAX_LENGTH})}
              </P>
            </Box>
            <Flex
              mt={'12px'}
              gap={'12px'}
              flexWrap={'wrap'}
            >
              <Button
                type='primary'
                onClick={handleSendClick}
                isLoading={isSending}
              >
                {l('membershipCancel_send')}
              </Button>
              <Button
                type='secondary'
                onClick={onClose}
                disabled={isSending}
              >
                {l('cancel')}
              </Button>
            </Flex>
          </Box>
        )
      }}
    </Formik>
  )
}
